const experience = [
  {
    title: "Full Stack Website and System Development",
    company: "Tankwa Tours & Travels",
    companyUrl: "https://tankwatravels.com/",
    logoSrc: "/tankwa_logo.jpg",
    employmentType: "Full time",
    startDate: "07/2025",
    endDate: "06/2026",
    location: "Bahir Dar, Ethiopia",
    highlights: [
      "Designed and implemented a company-wide Job Posting system, reducing hiring time by 43% for 6 job postings through integrated applicant evaluation tools.",
      "Developed an Event Management system to streamline company event coordination, including automated notifications and integrated report submissions, managing 3 weekly, 4 monthly and 6 annual events.",
      "Built a full-stack vehicle sales and rental platform that connects sellers with buyers. Built with a modern React frontend and a Node.js API, it supports vehicle listings, applications, and an admin workflow for managing posts.",
    ],
  },
  {
    title: "Faculty of Computing Association (FCA) Representative",
    company: "Bahir Dar University - BiT",
    companyUrl: "https://www.linkedin.com/company/bit-fca-club",
    logoSrc: "/faculty_association.jpg",
    employmentType: "Part time",
    startDate: "09/2025",
    endDate: "09/2026",
    location: "Bahir Dar, Ethiopia",
    highlights: [
      "Represented the Faculty of Computing at the University of Bahir Dar, providing a voice for the students and ensuring their concerns are heard.",
      "Organized and participated in peer-led trainings, and prepared hackathons for developers by collaborating with local tech companies.",
      "Actively contributed to a collaborative learning environment by promoting knowledge sharing and skill-building among computing students.",
    ],
  },
  {
    title: "Full Stack Web Development Internship",
    company: "Alyah Technology",
    companyUrl: "https://alyahsoftware.com/",
    logoSrc: "/alyah_logo.jpg",
    employmentType: "Full time",
    startDate: "03/2025",
    endDate: "06/2025",
    location: "Bahir Dar, Ethiopia",
    highlights: [
      "Co-developed a full-stack donation platform with 2 secure payment gateways and 80+ document verifications, securely processing 100+ transactions to connect 50+ verified individuals with direct financial aid.",
    ],
  },
];

export default experience;
